import { useEffect, useRef } from 'react';

interface UseBeforeUnloadOptions {
  enabled: boolean;
  message?: string;
}

export const useBeforeUnload = ({ 
  enabled, 
  message = 'You have unsaved changes. Are you sure you want to leave?' 
}: UseBeforeUnloadOptions) => {
  const messageRef = useRef(message);
  
  // Update message ref when message changes
  useEffect(() => {
    messageRef.current = message;
  }, [message]);

  useEffect(() => {
    if (!enabled) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = messageRef.current;
      return messageRef.current;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enabled]);
};